import type { SubZoneResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toSubZone } from './toSubZone';

// Builds a normalized `Data.SubZone` domain from a list of SubZone DTOs.
function toSubZoneDomain(args: { dtos: SubZoneResponse[] }) {
  const { dtos } = args;

  const subZoneDomain: NormalizedDomain<Data.SubZone> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const subZone = toSubZone(item);
      domainUtility.mutateAdd(subZoneDomain, subZone);
    },
  });

  return { subZoneDomain };
}

export { toSubZoneDomain };
